// import { createSlice } from '@reduxjs/toolkit'


// const initialState = {
//     user : null
// }
  
//   export const userSlice = createSlice({
//     name: 'user',
//     initialState,
//     reducers: {
//       setUserDetails : (state,action)=>{
//         state.user = action.payload
//       }
//     },
//   })
  
//   // Action creators are generated for each case reducer function
//   export const { setUserDetails } = userSlice.actions
  
//   export default userSlice.reducer
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    user: null,
    loading: false
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {

        setUserDetails: (state, action) => {
            state.user = action.payload
            state.loading = false
        },

        setUserLoading: (state, action) => {
            state.loading = action.payload
        },

        logoutUser: (state) => {
            state.user = null
        }

    },
})

export const { setUserDetails, logoutUser, setUserLoading } = userSlice.actions

export default userSlice.reducer